import React, { Component } from 'react'
import Auth from '../../Modules/Auth'
import axios from 'axios'
import './IntroMatterport.scss'
import { withCookies, Cookies } from 'react-cookie'
import { Link } from 'react-router-dom'
import HeaderMenu from '../../Components/Commons/HeaderMenu'
import ReactGA from 'react-ga'
import Select from 'react-select'

const groupStyles = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
}
const groupBadgeStyles = {
    backgroundColor: '#EBECF0',
    borderRadius: '2em',
    color: '#172B4D',
    display: 'inline-block',
    fontSize: 12,
    fontWeight: 'normal',
    lineHeight: '1',
    minWidth: 1,
    padding: '0.16666666666667em 0.5em',
    textAlign: 'center',
}

const formatGroupLabel = (data) => (
    <div style={groupStyles}>
        <span>{data.label}</span>
        <span style={groupBadgeStyles}>{data.options.length}</span>
    </div>
)

const FileViewer = ({ item }) => {
    return (
        <div className="file_item">
            <div className="file_view">
                <iframe
                    src={`https://my.matterport.com/show/?m=${item.result.id}&play=1&brand=0`}
                    frameBorder="0"
                    onmousewheel="false"
                    allowFullScreen
                    mozallowfullscreen
                    webkitallowfullscreen></iframe>
            </div>
        </div>
    )
}

class IntroMatterport extends Component {
    constructor(props) {
        super(props)

        this.state = {
            raw_drawings: [],
            drawings: [], // select component를 위한 데이터
            selectedOption: null, // 현재 선택된 도면
        }
    }

    UNSAFE_componentWillMount() {
        this.loadMatterports()
    }

    componentDidMount() {
        window.scrollTo(0, 0)
    }

    loadMatterports = () => {
        axios
            .get(`/api/solutionResults?project_id=${this.props.cookies.get('project')}&type=MATTERPORT`, {
                headers: {
                    Authorization: `bearer ${Auth.getToken()}`,
                },
            })
            .then((res) => {
                console.log(res.data)
                this.setState({ raw_drawings: res.data.data })
                const drawings = this.state.drawings
                let defaultDrawing = null

                for (let i = 0; i < res.data.total; i += 1) {
                    const item = res.data.data[i]
                    const drawing = {
                        value: item._id,
                        label: item.result.memo,
                    }
                    drawings.push(drawing)
                    if (defaultDrawing === null) {
                        defaultDrawing = drawing
                    }
                }

                // 첫번째 3d를 기본값으로 선택
                this.setState({ drawings }, () => {
                    if (defaultDrawing) {
                        this.setState({ selectedOption: defaultDrawing })
                    }
                })
            })
            .catch((err) => {
                console.log(err)
            })
    }

    renderDrawing = () => {
        if (this.state.selectedOption) {
            const drawings = this.state.raw_drawings
            return drawings.map((drawing) => {
                console.log(drawing._id)
                console.log(this.state.selectedOption)
                if (drawing._id === this.state.selectedOption.value) {
                    console.log(drawing)
                    return <FileViewer item={drawing} key={drawing._id} />
                }
            })
        }
    }

    handleSelect = (selectedOption) => {
        this.setState({ selectedOption })
    }

    render() {
        return (
            <div>
                <HeaderMenu />
                <div className="section_wrap section_wrap_menu">
                    <div className="intro_detail_wrap common_detail">
                        <div className="select_wrap">
                            <Select
                                name="drawing_files"
                                value={this.state.selectedOption}
                                onChange={this.handleSelect}
                                placeholder="데이터 선택"
                                clearable={false}
                                options={this.state.drawings}
                                formatGroupLabel={formatGroupLabel}
                                noOptionsMessage={() => '3D 촬영 데이터가 없습니다.'}
                            />
                        </div>

                        <div className="drawing_section">
                            <div className="content_wrap">{this.renderDrawing()}</div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default withCookies(IntroMatterport)



// WEBPACK FOOTER //
// ./Src/Containers/Intro/IntroMatterport.js